<!--
 * @description: 商品详情
 * @Author: Jay
 * @Date: 2021-09-25 14:15:51
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 14:15:04
-->
<template>
  <div>
    <!-- 顶部Tab 切换 -->
    <TopTab></TopTab>
    <!-- 页面内容 -->
    <div class="fix-width">
      <div class="padding">
        <!-- 商品详情介绍 -->
        <goods-info :goodsList="goodsData" :tabIndex="id"></goods-info>
      </div>
      <!-- 商品tab -->
      <goods-deta-tab :goodsList="goodsData"></goods-deta-tab>
    </div>
    <!-- 底部边距 -->
    <div class="margin-top margin-bottom"></div>
    <!-- 底部信息 -->
    <root-bottom></root-bottom>
  </div>
</template>

<script>
// 顶部Tab 切换
import TopTab from "@/components/tab/top-tab.vue";
// 底部信息
import rootBottom from "@/components/bottom/root-bottom.vue";
// 商品详情介绍
import goodsInfo from "../../components/carousel/goods-info.vue";
// 商品tab
import goodsDetaTab from "../../components/carousel/goods-deta-tab";
export default {
  name: "CulturalDetails",
  data() {
    return {
      goodsData: [],
      id: "",
    };
  },
  mounted() {
    //动态修改商品详情标题
    document.title = "商品详情";
  },
  created() {
    // console.log(this.$store.state.articleConter);
    let ifData = this.$store.state.articleConter;
    // console.log(ifData);
    if (ifData != "") {
      this.id = ifData.id;
      this.goodsData = ifData.list;
      //设置 临时 缓存
      const rowObj = JSON.stringify(ifData);
      sessionStorage.setItem("goods", rowObj);
    } else {
      let info = JSON.parse(window.sessionStorage.getItem("goods"));
      // console.log(info);
      this.id = info.id;
      this.goodsData = info.list;
    }
  },
  methods: {},
  components: {
    TopTab,
    rootBottom,
    goodsInfo,
    goodsDetaTab,
  },
};
</script>

<style lang="scss" scoped>
</style>